import TransportNewUI from '../pages/TransportNewUI';

/**
 * The New Transport UI is now live for everyone — no site-wide/preview toggle
 * and no personal "Classic View" override can bypass it (that override used
 * to always win, even after site-wide rollout, which is why some users kept
 * seeing the old classic board despite it being turned on for everyone).
 * Kept as a thin wrapper (rather than routing straight to `TransportNewUI` in
 * App.js) so a future UI change can be gated the same way without touching
 * the route itself.
 */
const TransportUIGate = ({ user, onLogout }) => <TransportNewUI user={user} onLogout={onLogout} />;

export default TransportUIGate;
